import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

import { JSEncrypt } from 'jsencrypt';

import { DataService } from 'src/app/shared/services/data.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class AirLogsService {
  private _headers: HttpHeaders;
  $encrypt: any;

  constructor(private _http: HttpClient, private _dataService: DataService) {
    this.$encrypt = new JSEncrypt({ default_key_size: 2048 as any });
    this.$encrypt.setPublicKey(environment.SERVER_PUBLIC_KEY);
  }

  sendLog(
    error: string,
    stackTrace: string,
    deviceInfo: Object,
    metadata: Object
  ) {
    const url = `${this._dataService.apiHost}/airLogs`;
    this._headers = new HttpHeaders({
      'Content-Type': 'application/json',
      encryption: this.$encrypt.encrypt(environment.API_KEY),
    });
    return this._http.post(
      url,
      { error, stackTrace, deviceInfo, metadata },
      { headers: this._headers }
    );
  }
}
